import { render } from "./PageAdmin.vue?vue&type=template&id=8eaabda4&scoped=true"
import script from "./PageAdmin.vue?vue&type=script&lang=js"
export * from "./PageAdmin.vue?vue&type=script&lang=js"

import "./PageAdmin.vue?vue&type=style&index=0&id=8eaabda4&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8eaabda4"]])

export default __exports__